import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Col, Grid, Row } from 'react-bootstrap';

@observer
export default class TrendsView extends React.Component {
    render() {
        const { post } = this.props.rootStore.trends;
        const { htmlBody, modifiedDate, title } = post;
        const options = {
            month: 'long',
            year: 'numeric'
        };
        let modified = '';
        let modifiedString = '';

        if (modifiedDate) {
            modified = new Date(post.modifiedDate);
            modifiedString = modified.toLocaleDateString('en-US', options);
        }

        return (
            <Row componentClass="main" className="trends-post">
                <div className="post-header">
                    <Grid>
                        <Col xs={12} sm={8}>
                            <Link to="/">{`< Back to market reports`}</Link>
                            <h1>{title}</h1>
                        </Col>
                    </Grid>
                </div>
                <Grid>
                    <Col xs={12} className="post-date">
                        <p>
                            {modifiedString
                                ? `Updated ${modifiedString}`
                                : null}
                        </p>
                    </Col>
                    <Col
                        xs={12}
                        sm={8}
                        md={9}
                        className="post-body"
                        dangerouslySetInnerHTML={{
                            __html: htmlBody
                        }}
                    />
                </Grid>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/trends/post/TrendsPostView.jsx